import { AlertType } from './types';
import { types, Instance, IStateTreeNode, getRoot } from 'mobx-state-tree';
import { IRootStore } from 'RootStore';

const { model, string, boolean } = types;

export const AlertStore = model('AlertStore', {
  show: boolean,
  message: string,
  type: string,
})
  .views((self) => ({}))
  .actions((self) => ({
    showAlert(message: string, type: AlertType = 'error') {
      self.message = message;
      self.type = type;
      self.show = true;
    },
    hideAlert() {
      self.show = false;
      self.message = '';
    },
  }));

export type IAlertStore = Instance<typeof AlertStore>;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const withAlertStore = (self: IStateTreeNode) => {
  return {
    views: {
      get alertStore(): IAlertStore {
        return getRoot<IRootStore>(self).alertStore;
      },
    },
  };
};
